import { motion, AnimatePresence } from 'framer-motion'
import { useNotifications } from '@/context/NotificationContext'
import type { AppToast } from '@/context/NotificationContext'
import { MessageSquare, MessageCircle, X } from 'lucide-react'

export default function GlobalToastContainer() {
  const { toasts, removeToast } = useNotifications()

  return (
    <div style={{ position: 'fixed', top: '1.5rem', right: '1.5rem', zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '0.75rem', pointerEvents: 'none' }}>
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, x: 50, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
            transition={{ type: 'spring', stiffness: 400, damping: 30 }}
            style={{
              pointerEvents: 'auto',
              width: '320px',
              background: 'rgba(24, 24, 27, 0.85)',
              backdropFilter: 'blur(16px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '1rem',
              padding: '1rem',
              boxShadow: '0 10px 40px -10px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1)',
              display: 'flex',
              gap: '1rem',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {/* Glossy top edge highlight */}
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)' }} />
            
            <div style={{ 
              width: '2.5rem', height: '2.5rem', borderRadius: '50%', flexShrink: 0,
              background: toast.type === 'chat' ? 'linear-gradient(135deg, #3b82f6, #8b5cf6)' : 'linear-gradient(135deg, #10b981, #3b82f6)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: toast.type === 'chat' ? '0 0 15px rgba(59,130,246,0.4)' : '0 0 15px rgba(16,185,129,0.4)'
            }}>
              {toast.type === 'chat' ? <MessageSquare size={16} color="#fff" /> : <MessageCircle size={16} color="#fff" />}
            </div>

            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '0.25rem', paddingTop: '0.25rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 700, fontSize: '0.875rem', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {toast.title}
                </span>
                <button onClick={() => removeToast(toast.id)} style={{ background: 'none', border: 'none', color: '#a1a1aa', cursor: 'pointer', display: 'flex' }}>
                  <X size={14} />
                </button>
              </div>
              <p style={{ margin: 0, fontSize: '0.8125rem', color: '#d4d4d8', lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                {toast.message}
              </p>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
